import React from 'react';
import { ConditionStatus } from '../../types/conditions';
import { CheckCircle2, AlertCircle, Eye, Send } from 'lucide-react';
interface StatusBadgeProps {
  status: ConditionStatus;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  const getStatusConfig = () => {
    switch (status) {
      case 'Approved':
        return {
          bg: 'bg-green-100',
          text: 'text-green-800',
          icon: <CheckCircle2 className="w-3.5 h-3.5 mr-1" data-id="element-235" />
        };
      case 'Needs Info':
        return {
          bg: 'bg-red-100',
          text: 'text-red-800',
          icon: <AlertCircle className="w-3.5 h-3.5 mr-1" data-id="element-236" />
        };
      case 'Requested':
        return {
          bg: 'bg-slate-100',
          text: 'text-slate-700',
          icon: <Send className="w-3.5 h-3.5 mr-1" data-id="element-237" />
        };
      case 'Review':
      default:
        return {
          bg: 'bg-amber-100',
          text: 'text-amber-800',
          icon: <Eye className="w-3.5 h-3.5 mr-1" data-id="element-238" />
        };
    }
  };
  const config = getStatusConfig();
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`} data-id="element-239">
      {config.icon}
      {status}
    </span>;
}